_ = require 'underscore'
Confirm = require 'views/lib/confirm'
CustomFieldCreateView = require 'views/custom-field/custom-field-create-view'
CustomFieldEditView = require 'views/custom-field/custom-field-edit-view'
Keyboard = require 'lib/keyboard'
PopOver = require 'views/lib/pop-over'
View = require 'view'
Util = require 'lib/util'
t = require('views/internal/teacup-with-helpers')('custom_fields')
trackUe = require 'debug/trackUe'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'
MAX_FIELDS = 50

template = t.renderable ({ canCreate, fields } = {}) ->
  t.div ->
    if fields.length == 0 && canCreate
      t.p ->
       t.format 'no custom fields'
      t.hr()
      t.a '.custom-field.js-add-field', { href: '#' }, ->
        t.icon 'add'
        t.span '.custom-field-name', ->
         t.format 'new field'
    else
      t.ul ->
        fields.map (cf) ->
          t.li '.custom-field.js-field', { href: '#', idCustomField: cf.id }, ->
            t.icon cf.icon(), { class: 'js-drag-handle draggable' }
            t.a '.custom-field-name.js-edit-field', { href: '#' }, ->
              t.text cf.get('name')
        if canCreate
          t.hr()
          t.a '.custom-field.js-add-field', { href: '#' }, ->
            t.icon 'add'
            t.span '.custom-field-name', ->
             t.format 'new field'


module.exports = class CustomFieldsButtonView extends View
  viewTitleKey: 'custom fields'

  initialize: ->
    @board = @options.board

  render: ->
    fields = @board.customFieldList.models

    canCreate = @board.editable() &&
      @board.isPluginEnabled(CUSTOM_FIELDS_ID) &&
      @board.customFieldList.length < MAX_FIELDS

    @$el.html template({ canCreate, fields })

    if fields.length > 1
      $fieldList = @$('.js-field').first().closest('ul')
      $fieldList.sortable
        axis: 'y'
        cursor: 'move'
        delay: '75'
        distance: '5'
        handle: '.js-drag-handle'
        tolerance: 'pointer'
        placeholder: 'field-list-option placeholder'
        items: '.js-field'
        sort: (event, ui) =>
          formTop = $fieldList.parent().parent().offset().top
          top = event.clientY - formTop
          ui.helper.css({ top: "#{top}px" })
        update: (event, ui) =>
          idCustomField = ui.item.attr('idCustomField')
          newIndex = ui.item.parent().children().index(ui.item)
          @board.customFieldList.get(idCustomField).move(newIndex)

    @

  events:
    'click .js-add-field': 'createCustomField'
    'click .js-edit-field': 'editCustomField'

  createCustomField: (e) ->
    Util.stop(e)
    PopOver.pushView
      elem: @$(e.target)
      view: CustomFieldCreateView
      options: { @model, @modelCache, board: @board }

  editCustomField: (e) ->
    $el = @$(e.target).closest('.js-field')
    idCustomField = $el.attr('idCustomField')
    customField = @board.customFieldList.get(idCustomField)
    PopOver.pushView
      elem: $el
      view: CustomFieldEditView
      options: { @model, @modelCache, board: @board, customField }



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-fields-button-view.coffee